import { AnalyticsServiceSettings } from '../../../models/AnalyticsServiceSettings'

//Fixes typescript errors with trying to access window.heap
declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fbq: any
  }
}

// Abstract fbq interaction into a helper function
export const fbqHelper = (method: string, ...args: any[]) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq(method, ...args)
  }
}

let fbLoaded = false

export const makeFacebookPixelAnalyticsPlugin = (settings: AnalyticsServiceSettings[]) => {
  const facebookPixelSettings = settings.find(
    (setting) => setting.service_name === 'facebook_pixel',
  ) as AnalyticsServiceSettings<{ pixel_id: string }, object> | undefined

  if (!facebookPixelSettings?.parameters?.pixel_id) {
    console.warn('Facebook Pixel is not configured correctly.')

    return undefined
  }

  const pixelId = facebookPixelSettings.parameters.pixel_id

  return {
    name: 'facebook-pixel',
    /**
     * Initializes Facebook Pixel by checking if it's already loaded.
     */
    initialize: () => {
      if (typeof window !== 'undefined' && !fbLoaded) {
        if (!window.fbq) {
          console.warn('Facebook Pixel is not loaded.')
          return false
        }

        fbqHelper('init', pixelId)
        fbLoaded = true
        return true
      }

      return false
    },
    /**
     * Tracks page views by using the Facebook Pixel 'PageView' event.
     */
    page: () => {
      if (!fbLoaded) return

      /**
       * We've disabled the page view tracking for now, as it can cause duplication
       * with the customer's own page tracking.
       */
      // fbqHelper('track', 'PageView')
    },
    /**
     * Tracks custom events using Facebook Pixel.
     */
    track: ({ payload }: { payload: { event: string; properties: object } }) => {
      if (!fbLoaded) return

      fbqHelper('track', payload.event, payload.properties)
    },
    /**
     * Returns whether Facebook Pixel has been loaded.
     */
    loaded: (): boolean => {
      return fbLoaded
    },
  }
}

export default makeFacebookPixelAnalyticsPlugin
